// Initialize Flickity
(function() {
  var carousel = document.querySelector('.testimonial-carousel');
  if (!carousel) return;
  
  var flktyTestimonial = new Flickity(carousel, {
    wrapAround: true,
    cellAlign: 'center',
    percentPosition: false
  });
  
  // Resize after layout is complete to fix centering with position:absolute
  requestAnimationFrame(function() {
    flktyTestimonial.resize();
  });
})();

// Add dynamic section classes to sections
(function() {
  let classElements = null;
  if (classElements = document.querySelectorAll(".js-class-source")) {
    classElements.forEach(classElement => {
      let cList = classElement.classList;
      let nearestSection = classElement.closest(".shopify-section");
      cList.remove("js-class-source");
      cList.forEach(cl => {
        nearestSection?.classList.add(cl);
      })
      classElement.remove();
    });
  };
})();

// Dynamic scroll for buttons
(function() {
  let buttonElements = null;
  if (buttonElements = document.querySelectorAll("a[data-element-id-link]")) {
    buttonElements.forEach(buttonElement => {
      let videoPlaying = false;
      if (buttonElement instanceof HTMLElement ) {
        let targetElementId = buttonElement.dataset.elementIdLink;
        if (targetElementId != null) {
          let targetElement = document.getElementById(targetElementId);

          if (targetElement != null) {
            buttonElement.addEventListener('click', (event) => {

              // Play video
              if (!targetElement.classList.contains('deferred-media-container__playing')) {
                if (buttonElement.dataset.videoPlay == 'true') {
                  if (targetElement.classList.contains('video-snippet') ) {
                    let targetVideo = customElements.get(targetElement.tagName.toLowerCase());
                    if (targetVideo != undefined) {
                      let content = targetElement.querySelector('template')?.content.firstElementChild?.cloneNode(true);
                      if (content != undefined) {
                        // This is essentially media.js loadContent()
                        targetElement.setAttribute('data-media-loaded', 'true');
                        targetElement.appendChild(content);
                        targetElement.classList.add('deferred-media-container__playing');
                        targetElement.refs.deferredMediaPlayButton?.classList.add('deferred-media__playing');
                        if (content instanceof HTMLVideoElement && content.getAttribute('autoplay')) {
                          // force autoplay for safari
                          content.play();
                        }
                      }
                    }
                  }
                  else if (targetElement.classList.contains('bunny-video')) {
                    let iframe = targetElement.querySelector('iframe');
                    const player = new playerjs.Player(iframe);
                    
                    player.on("play", () => {
                      targetElement.classList.add('deferred-media-container__playing');
                    });
                    player.on('pause', () => {
                      targetElement.classList.remove('deferred-media-container__playing');
                    });
                    player.on('ready', () => player.play());
                  }
                };
              };
            });
          };
        };
      };
    });
  };
})();

document.querySelectorAll('.bunny-video-control-overlay').forEach(controlOverlay => {
  controlOverlay.addEventListener('click', () => {
    let frame = controlOverlay.parentElement.querySelector('iframe');

    if (frame) {
      const player = new playerjs.Player(frame);

      player.on('ready', () => {
        player.getPaused(paused => {
          paused ? player.play() : player.pause();
        });
      });
    }
  });
});

// Case Studies fullscreen viewer
(function() {
  const roots = document.querySelectorAll('.case-studies-root');
  if (!roots.length) return;

  roots.forEach((root) => {
    const links = Array.from(
      root.querySelectorAll('.case-study-card .group-block__link')
    );
    if (!links.length) return;

    const slides = links
      .map((link) => {
        const href = link.getAttribute('href');
        if (!href) return null;
        // data-lightbox-fit="contain" on the trigger link fits the image to the
        // viewport (mobile captures) instead of the default width-fill + scroll
        // (long desktop site screenshots).
        return { src: href, contain: link.dataset.lightboxFit === 'contain' };
      })
      .filter((slide) => !!slide);

    if (!slides.length) return;

    const dialog = document.createElement('dialog');
    dialog.className = 'case-studies-dialog';
    dialog.setAttribute('aria-label', 'Case study image viewer');

    dialog.innerHTML =
      '<div class="case-studies-dialog__overlay">' +
      '  <div class="case-studies-dialog__header">' +
      '    <div class="case-studies-dialog__counter"></div>' +
      '    <button type="button" class="case-studies-dialog__close" aria-label="Close case study viewer">&times;</button>' +
      '  </div>' +
      '  <div class="case-studies-dialog__body">' +
      '    <button type="button" class="case-studies-dialog__arrow case-studies-dialog__arrow--prev" aria-label="Previous case study"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"></path></svg></button>' +
      '    <div class="case-studies-dialog__image-wrap">' +
      '      <div class="case-studies-dialog__spinner" aria-hidden="true"></div>' +
      '      <img class="case-studies-dialog__image" alt="">' +
      '    </div>' +
      '    <button type="button" class="case-studies-dialog__arrow case-studies-dialog__arrow--next" aria-label="Next case study"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"></path></svg></button>' +
      '  </div>' +
      '</div>';

    document.body.appendChild(dialog);

    const overlay = dialog.querySelector('.case-studies-dialog__overlay');
    const header = dialog.querySelector('.case-studies-dialog__header');
    /** @type {HTMLImageElement | null} */
    const imageElement = dialog.querySelector('.case-studies-dialog__image');
    const closeButton = dialog.querySelector('.case-studies-dialog__close');
    const prevButton = dialog.querySelector('.case-studies-dialog__arrow--prev');
    const nextButton = dialog.querySelector('.case-studies-dialog__arrow--next');
    const counter = dialog.querySelector('.case-studies-dialog__counter');
    const spinner = dialog.querySelector('.case-studies-dialog__spinner');

    let currentIndex = 0;
    /** @type {number | null} */
    let controlsTimeoutId = null;

    function updateCounter() {
      if (!counter) return;
      counter.textContent = (currentIndex + 1) + ' / ' + slides.length;
    }

    function showControls() {
      dialog.classList.remove('case-studies-dialog--controls-hidden');
    }

    function scheduleHideControls() {
      if (controlsTimeoutId != null) window.clearTimeout(controlsTimeoutId);
      controlsTimeoutId = window.setTimeout(() => {
        dialog.classList.add('case-studies-dialog--controls-hidden');
      }, 2500);
    }

    function handleUserActivity() {
      if (!dialog.open) return;
      showControls();
      scheduleHideControls();
    }

    function lockBackground() {
      const html = document.documentElement;
      const body = document.body;

      if (dialog.dataset.scrollLockApplied === 'true') return;
      dialog.dataset.scrollLockApplied = 'true';

      const scrollbarWidth = window.innerWidth - html.clientWidth;

      dialog.dataset.prevHtmlOverflow = html.style.overflow || '';
      dialog.dataset.prevBodyOverflow = body.style.overflow || '';
      dialog.dataset.prevBodyPaddingRight = body.style.paddingRight || '';

      html.style.overflow = 'hidden';
      body.style.overflow = 'hidden';

      if (scrollbarWidth > 0) {
        const computed = window.getComputedStyle(body).paddingRight;
        const current = parseFloat(computed) || 0;
        body.style.paddingRight = `${current + scrollbarWidth}px`;
      }
    }

    function unlockBackground() {
      const html = document.documentElement;
      const body = document.body;

      if (dialog.dataset.scrollLockApplied !== 'true') return;

      html.style.overflow = dialog.dataset.prevHtmlOverflow || '';
      body.style.overflow = dialog.dataset.prevBodyOverflow || '';
      body.style.paddingRight = dialog.dataset.prevBodyPaddingRight || '';

      delete dialog.dataset.scrollLockApplied;
      delete dialog.dataset.prevHtmlOverflow;
      delete dialog.dataset.prevBodyOverflow;
      delete dialog.dataset.prevBodyPaddingRight;
    }

    /**
     * @param {number} index
     * @param {boolean} [isInitial]
     */
    function show(index, isInitial) {
      if (!slides.length || !imageElement) return;

      if (index < 0) {
        index = slides.length - 1;
      } else if (index >= slides.length) {
        index = 0;
      }

      currentIndex = index;
      updateCounter();

      const slide = slides[index];
      if (!slide) return;

      dialog.classList.toggle('case-studies-dialog--contain', slide.contain);

      /**
       * Start loading the new image and fade it in when ready.
       */
      function loadAndFadeIn() {
        if (spinner) {
          dialog.classList.add('case-studies-dialog--loading');
        }

        imageElement.onload = () => {
          dialog.classList.remove('case-studies-dialog--loading');
          imageElement.style.opacity = '1';
        };

        imageElement.src = slide.src;
      }

      // If there is no current image rendered yet OR this is the initial open,
      // just load and fade in (no prior fade-out of an old image).
      if (isInitial || !imageElement.naturalWidth) {
        imageElement.style.opacity = '0';
        loadAndFadeIn();
        return;
      }

      // For arrow navigation between already-loaded images:
      // fade the current image out first, then swap src and fade the new one in.
      imageElement.style.opacity = '0';

      /** @param {TransitionEvent} event */
      function handleTransitionEnd(event) {
        if (event.propertyName !== 'opacity') return;
        imageElement.removeEventListener('transitionend', handleTransitionEnd);
        loadAndFadeIn();
      }

      imageElement.addEventListener('transitionend', handleTransitionEnd);
    }

    /**
     * @param {number} index
     * @param {Event} [event]
     */
    function openAt(index, event) {
      if (event) {
        event.preventDefault();
      }

      lockBackground();
      // Initial open: do not fade out a previous image, just fade in the new one.
      show(index, true);
      dialog.showModal();
      showControls();
      scheduleHideControls();
    }

    function close() {
      if (!dialog.open) return;

      // If we have the CSS closing animation class, use it; otherwise, close immediately.
      const hasClosingAnimation =
        getComputedStyle(dialog).animationName.includes('case-studies-dialog-fade-out');

      if (!hasClosingAnimation) {
        dialog.close();
        unlockBackground();
        // Clear image to prevent flash when reopening
        if (imageElement) {
          imageElement.src = '';
          imageElement.style.opacity = '0';
        }
        return;
      }

      if (dialog.classList.contains('case-studies-dialog--closing')) return;

      dialog.classList.add('case-studies-dialog--closing');

      const handleAnimationEnd = () => {
        dialog.removeEventListener('animationend', handleAnimationEnd);
        dialog.classList.remove('case-studies-dialog--closing');
        if (dialog.open) dialog.close();
        unlockBackground();
        // Clear image to prevent flash when reopening
        if (imageElement) {
          imageElement.src = '';
          imageElement.style.opacity = '0';
        }
      };

      dialog.addEventListener('animationend', handleAnimationEnd);
    }

    if (closeButton) {
      // Capture so this runs even if something else stops propagation later.
      closeButton.addEventListener(
        'click',
        () => {
          close();
        },
        { capture: true }
      );
    }

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        show(currentIndex - 1);
        handleUserActivity();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        show(currentIndex + 1);
        handleUserActivity();
      });
    }

    dialog.addEventListener('keydown', (event) => {
      handleUserActivity();
      if (event.key === 'Escape') {
        close();
      } else if (event.key === 'ArrowRight') {
        show(currentIndex + 1);
      } else if (event.key === 'ArrowLeft') {
        show(currentIndex - 1);
      }
    });

    if (overlay) {
      overlay.addEventListener('pointermove', handleUserActivity);
      overlay.addEventListener('pointerdown', handleUserActivity);

      // Treat clicks on overlay background (anywhere that is not image/arrows/close)
      // as backdrop clicks that close the dialog.
      overlay.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        if (target.closest('.case-studies-dialog__image-wrap')) return;
        if (target.closest('.case-studies-dialog__arrow')) return;

        // If user hits the close button or any empty/header/background area, close.
        if (target.closest('.case-studies-dialog__close') || target === overlay) {
          close();
        }
      });
    }

    links.forEach((link, index) => {
      link.addEventListener('click', (event) => {
        openAt(index, event);
      });
    });
  });
})();

// CognitoForm Labels to placeholders

// function changeLabelsWithPlaceholders() {
//   const labels = document.querySelectorAll('label.cog-label');

//   labels.forEach(label => {
//     const inputId = label.getAttribute('for');
//     const input = document.getElementById(inputId);
//     if (!input) return;
//     input.setAttribute('placeholder', label.textContent.split('*')[0].trim() || '');
//     label.style.display = 'none';
//   });
// };

function addClassToCognitoButton() {
  const btn = document.querySelector('button.cog-button--submit');
  if (btn) {
    btn.classList.add('button');
  }
}

function stylingCognito() {
  // tchangeLabelsWithPlaceholders();
  addClassToCognitoButton();
}

function waitForElement(selector, callback) {
    const element = document.querySelector(selector);
    if (element) {
        callback(element);
    } else {
        setTimeout(() => waitForElement(selector, callback), 50);
    }
}

if (window.location.pathname === '/pages/contact-us') {
  waitForElement('.cog-form__container', (congnitoContainer) => {
    const observer = new MutationObserver(stylingCognito);
    observer.observe(congnitoContainer, { childList: true, subtree: true });
    stylingCognito();
  });
}

/* Adjust Scroll Position After Cognito Form Submission */


function scrollToElementWithOffset(element, offset) {
  const y = element.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({ top: y, behavior: 'smooth' });
}

function getHeaderOffset() {
  const header = document.getElementById('header-component');
  return header ? header.offsetHeight + 100 : 200;
}

/* Scroll to success message after form submission, accounting for fixed header */

if (window.location.pathname === '/pages/contact-us') {
  waitForElement('.cog-form', (form) => {
    const observer = new MutationObserver(() => {
      const successMessage = document.querySelector('.cog-confirmation');
      if (successMessage) {
        console.log('Success message detected, adjusting scroll position...');
        scrollToElementWithOffset(successMessage, getHeaderOffset());
        observer.disconnect();
      }
    });

    observer.observe(form, { childList: true, subtree: true });
  });
}

/** Preserve scroll position when navigating between blog tag pages via the blog nav. */

if (window.location.pathname.includes('/blogs/ecommerce-pulse')) {
  const savedScrollY = sessionStorage.getItem('blogNavScrollY');
  if (savedScrollY !== null) {
    sessionStorage.removeItem('blogNavScrollY');
    window.scrollTo({ top: parseInt(savedScrollY, 10), behavior: 'instant' });
  }

  const blogNav = document.querySelector('.blog-nav');
  if (blogNav) {
    blogNav.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        sessionStorage.setItem('blogNavScrollY', String(window.scrollY));
      });
    });
  }
}

/** the fade effect for overflowing blog nav */

waitForElement('.blog-nav', (blogNav) => {
  const ul = blogNav.querySelector('ul');
  
  function checkOverflow() {
    if (ul.scrollWidth > ul.clientWidth) {
      blogNav.classList.add('is-overflowing');
    } else {
      blogNav.classList.remove('is-overflowing');
    }
  }

  function checkScrollEnd() {
    // scrollWidth - clientWidth = maximum scroll position
    const isAtEnd = ul.scrollLeft + ul.clientWidth >= ul.scrollWidth - 5; // 5px tolerance
    if (isAtEnd) {
      blogNav.classList.remove('is-overflowing');
    } else if (ul.scrollWidth > ul.clientWidth) {
      blogNav.classList.add('is-overflowing');
    }
  }

  checkOverflow();
  window.addEventListener('resize', checkOverflow);
  ul.addEventListener('scroll', checkScrollEnd); // watches scroll position
});